import api from "./api";

const controller = "/Cargo/"

export const GetCargoViewById = async (id) => {
    const response = await api.get(
        controller + "GetCargoViewById",{params: {id}}
    );
    return response.data;
}
export const PostCargo = (dataPost) =>
    api.post(
        controller + "PostCargo",dataPost
    )
export const GetsCargoViewSearchBasic = async (descripcion, idEstado) => {
    const response = await api.get(
        controller + "GetsCargoViewSearchBasic",{params: {descripcion, idEstado}}
    );
    return response.data;
}
export const AnnulCargo = (id) =>
    api.post(
        controller + "AnnulCargo",{params: {id}}
    )
export const ActiveCargo = (id) =>
    api.post(
        controller + "ActiveCargo",{params: {id}}
    )
